import Fetch from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchDataModels: ({ category }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_DATA_MODELS,
    readStatus,
    { category },
  ),
  useFetchDatasetDataModel: ({ category, code }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_DATASET_DATA_MODEL,
    readStatus,
    { category, code },
  ),
};
